(function(){
  'use strict';
  function ready(){
    var root=document.querySelector('[data-sj-root]');
    if(!root||root.dataset.sjSamples==='1')return;
    root.dataset.sjSamples='1';
    var modal=root.querySelector('.sj-modal'),resultList=root.querySelector('[data-sj-result-list]'),panel=root.querySelector('[data-sj-picks]');
    if(!modal||!resultList||!panel)return;
    var storage='sultanea-jackpot-club-v2',busy=false,searchVersion=0,options=[],activeIndex=null,activeRoundId=null,activePrizeId=null,searchTimer,pendingChoices=[],catalogue=null,catalogueTask=null,catalogueAt=0,decks={};
    var names={dec2:2,double2:2,triple2:2,quad2:2,quint2:2,dec5:5,double5:5,dec10:10};
    var amounts={dec2:1,double2:2,triple2:3,quad2:4,quint2:5,dec5:1,double5:2,dec10:1};
    var box=document.createElement('section');box.className='sj-sample-picker';box.hidden=true;box.setAttribute('aria-label','Elegir perfume de la muestra');
    box.innerHTML='<h3>Elige el perfume de tu muestra</h3><p data-sjs-text>Busca un perfume. El aroma que elijas quedará asociado a tu premio.</p><label for="sjs-query">Busca tu perfume</label><input id="sjs-query" type="search" autocomplete="off" maxlength="80" placeholder="Yara, Hawas, Lattafa..."><p data-sjs-status role="status" aria-live="polite"></p><div data-sjs-results class="sj-sample-results"></div><button type="button" data-sjs-shuffle class="sj-sample-shuffle">CAMBIAR OPCIONES ↻</button><button type="button" data-sjs-back class="sj-sample-back">Volver a los premios</button><p class="sj-sample-disclaimer">Las fragancias elegidas se guardan como nota en el pedido. No se añade ningún producto ni se modifican precios, descuentos o gastos de envío. La tienda validará el premio y la tarjeta Club antes de prepararlo.</p>';
    panel.insertAdjacentElement('afterend',box);
    var title=box.querySelector('h3'),query=box.querySelector('input'),message=box.querySelector('[data-sjs-status]'),results=box.querySelector('[data-sjs-results]');
    var change=document.createElement('button');change.type='button';change.className='sj-choice-btn sj-sample-change';change.textContent='ELEGIR O CAMBIAR PERFUME DE MI MUESTRA';change.hidden=true;panel.appendChild(change);
    function state(){try{return JSON.parse(localStorage.getItem(storage))||{}}catch(e){return {}}}
    function isSample(id){return Object.prototype.hasOwnProperty.call(names,id)}
    function path(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/').replace(/\/?$/,'/')}
    function refresh(){
      var s=state();change.hidden=!isSample(s.selected)||!Number.isInteger(s.selectedIndex);
      if(!change.hidden){var count=amounts[s.selected]||1;change.textContent='ELEGIR O CAMBIAR '+count+' '+(count===1?'FRAGANCIA':'FRAGANCIAS')+' DE MIS MUESTRAS';}
    }
    var shuffleButton=box.querySelector('[data-sjs-shuffle]');
    function hide(){box.hidden=true;activeIndex=null;pendingChoices=[];searchVersion++;query.value='';results.textContent=''}
    function open(i,roundId){
      var s=state(),rid=roundId||s.roundId,reward=(s.rewards||[]).find(function(item){return item.roundId===rid&&item.index===i}),id=reward?reward.prizeId:s.spins&&s.spins[i];
      if(!isSample(id)||busy||(s.selectedRoundId&&(s.selectedRoundId!==rid||s.selectedRoundIndex!==i)))return;
      activeIndex=i;activeRoundId=rid;activePrizeId=id;pendingChoices=[];box.hidden=false;title.textContent='Elige '+amounts[id]+' '+(amounts[id]===1?'perfume':'perfumes')+' para tus muestras de '+names[id]+' ml';
      box.querySelector('[data-sjs-text]').textContent='Elige una fragancia por muestra. Puedes repetir perfume. Necesitas un frasco entero y tarjeta Sultanea Club. Se guardará una nota para preparar el pedido.';
      query.value='';results.textContent='';message.textContent='Cargando perfumes de Sultanea...';
      load('');box.scrollIntoView({behavior:'smooth',block:'nearest'});
    }
    function eligible(product,ml){
      if(!product||!Array.isArray(product.variants))return null;
      var available=product.variants.filter(function(v){return v.available===true;});
      var exact=new RegExp('(?:^|[^0-9])'+ml+'\\s*ml(?:$|[^a-z0-9])','i');
      return available.find(function(v){return exact.test(v.title||'')})||
        available.find(function(v){return /frasco\s*entero|bote\s*entero|full\s*bottle/i.test(v.title||'')})||
        available[0]||null;
    }
    function normal(value){return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();}
    function catalogueProduct(product){
      var title=normal(product.title),tags=(Array.isArray(product.tags)?product.tags:String(product.tags||'').split(',')).map(normal);
      if(tags.indexOf('no venta directa')!==-1||String(product.id)==='10476651577673')return false;
      if(/(?:^|\s)(pack|packs|set|cofre|cofres|gift)(?:\s|$)|desodorante|ambientador|difusor|mikado|room spray|home fragrance|perfume ambiente|fragancia de hogar|vela aromatica|body mist|body spray|bruma|crema|serum|champu|gel de|aceite corporal|capilar|cabello/.test(title))return false;
      return /perfum|eau de|attar/.test(title+' '+normal(product.type))||
        tags.some(function(t){return /^(hombre|mujer|unisex|perfumes?)$/.test(t);})||
        product.variants.some(function(v){return /frasco\s*entero|bote\s*entero|full\s*bottle/i.test(v.title||'');});
    }
    function fetchCatalogue(){
      if(catalogue&&Date.now()-catalogueAt<120000)return Promise.resolve(catalogue);
      if(catalogueTask)return catalogueTask;
      var all=[],seenPages={};
      function page(number){
        if(number>100||seenPages[number])throw Error('No se pudo recorrer todo el catálogo.');
        seenPages[number]=true;
        var url=path()+'?section_id=sultanea-jackpot-catalog&page='+number;
        var themeId=root.dataset.sjThemeId;
        if(root.dataset.sjThemeRole!=='main'&&themeId)url+='&preview_theme_id='+encodeURIComponent(themeId);
        return fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'}})
          .then(function(r){if(!r.ok)throw Error('No se pudo cargar el catálogo.');return r.text();})
          .then(function(html){
            var doc=new DOMParser().parseFromString(html,'text/html'),node=doc.querySelector('[data-sjs-catalog]');
            if(!node)throw Error('Actualiza la página para cargar el catálogo nuevo.');
            var data=JSON.parse(node.textContent);
            if(!data||data.page!==number||!Number.isInteger(data.pages)||data.pages<0||!Array.isArray(data.products))throw Error('No se pudo leer el catálogo.');
            all=all.concat(data.products);
            if(number<data.pages)return page(number+1);
            var seen={};
            catalogue=all.filter(function(p){
              if(!p||!p.id||seen[p.id]||!Array.isArray(p.variants))return false;
              seen[p.id]=true;return catalogueProduct(p);
            });
            catalogueAt=Date.now();decks={};return catalogue;
          });
      }
      catalogueTask=page(1).finally(function(){catalogueTask=null;});
      return catalogueTask;
    }
    function mix(items){
      var copy=items.slice();
      for(var i=copy.length-1;i>0;i--){
        var j=Math.floor(Math.random()*(i+1)),tmp=copy[i];copy[i]=copy[j];copy[j]=tmp;
      }
      return copy;
    }
    function nextBatch(pool,key){
      var signature=pool.map(function(p){return p.variantId;}).join(',');
      var deck=decks[key];
      if(!deck||deck.signature!==signature)deck=decks[key]={signature:signature,remaining:[],previous:[]};
      if(!deck.remaining.length){
        var previous=new Set(deck.previous);
        var fresh=mix(pool);
        deck.remaining=fresh.filter(function(p){return !previous.has(p.variantId);}).concat(fresh.filter(function(p){return previous.has(p.variantId);}));
      }
      var batch=deck.remaining.splice(0,8);
      deck.previous=batch.map(function(p){return p.variantId;});
      return batch;
    }
    function load(term){
      if(activeIndex===null||busy)return;
      var s=state(),vol=names[activePrizeId],version=++searchVersion,needle=normal(term);
      results.textContent='';options=[];shuffleButton.disabled=true;shuffleButton.textContent='CARGANDO OPCIONES…';
      message.textContent='Buscando en todas las referencias de perfume disponibles…';
      fetchCatalogue().then(function(products){
        if(version!==searchVersion||box.hidden)return;
        var pool=products.filter(function(p){
          var haystack=normal(p.title+' '+p.vendor+' '+(Array.isArray(p.tags)?p.tags.join(' '):p.tags));
          return !needle||needle.split(/\s+/).every(function(word){return haystack.indexOf(word)!==-1;});
        }).map(function(p){
          var v=eligible(p,vol);
          return v?{name:p.title,ml:vol,variantId:v.id,variantName:v.title}:null;
        }).filter(Boolean);
        options=nextBatch(pool,vol+'|'+needle);
        message.textContent=options.length?'Muestra '+(pendingChoices.length+1)+' de '+(amounts[activePrizeId]||1)+'. '+pool.length+' referencias disponibles'+(needle?' para esta búsqueda':'')+'. Elige una o pulsa Cambiar opciones.':'No encontramos perfumes disponibles para esta búsqueda. Prueba otro nombre.';
        options.forEach(function(opt,i){
          var b=document.createElement('button');b.type='button';b.className='sj-sample-result';b.dataset.sampleChoice=String(i);
          b.appendChild(document.createTextNode(opt.name));
          var note=document.createElement('small');note.textContent='Muestra solicitada: '+vol+' ml';b.appendChild(note);
          results.appendChild(b);
        });
        results.scrollTop=0;
        shuffleButton.textContent='CAMBIAR OPCIONES ↻';shuffleButton.disabled=pool.length<=8;
      }).catch(function(error){
        if(version!==searchVersion||box.hidden)return;
        message.textContent=error&&error.message||'No se pudo consultar el catálogo. Pulsa Reintentar.';
        shuffleButton.textContent='REINTENTAR CARGA ↻';shuffleButton.disabled=false;
      });
    }
    function fetchCart(){
      return fetch(path()+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
        .then(function(res){if(!res.ok)throw Error('No se puede comprobar el carrito');return res.json()});
    }
    function isWholeBottle(item){
      return !!(item&&/frasco\s*entero|bote\s*entero|full\s*bottle/i.test(String(item.variant_title||'')));
    }
    function saveChoice(opt){
      if(busy||activeIndex===null)return;
      var s=state(),index=activeIndex,id=activePrizeId,ml=names[id],count=amounts[id];
      if(!ml||!count||!Number.isInteger(index)||!opt||(s.selectedRoundId&&(s.selectedRoundId!==activeRoundId||s.selectedRoundIndex!==index)))return;
      if(pendingChoices.length+1<count){
        pendingChoices.push(opt);
        query.value='';results.textContent='';
        message.textContent='Elegida la muestra '+pendingChoices.length+' de '+count+'. Ahora elige la siguiente fragancia.';
        load('');return;
      }
      var chosen=pendingChoices.concat([opt]);
      busy=true;shuffleButton.disabled=true;results.querySelectorAll('button').forEach(function(b){b.disabled=true;});query.disabled=true;message.textContent='Registrando '+count+' '+(count===1?'muestra':'muestras')+' para el pedido…';
      fetchCart().then(function(cart){
        var bottles=(cart.items||[]).filter(isWholeBottle).reduce(function(total,item){return total+(Number(item.quantity)||0);},0);
        if(bottles<1)throw Error('Añade al carrito un frasco entero para solicitar el premio.');
        var scents=chosen.map(function(x,i){return (i+1)+'. '+x.name;}).join(' | ');
        var label=count+' '+(count===1?'MUESTRA':'MUESTRAS')+' DE '+ml+' ML';
        var note='PREPARAR '+label+': '+scents+'. Verificar pedido pagado, tarjeta Sultanea Club y premio antes de entregar.';
        var attrs={
          'Sultanea Jackpot - Premio solicitado':'🧪 '+label,
          'Sultanea Jackpot - Tirada elegida':String(index+1)+' de 3',
          'Sultanea Jackpot - Estado':'PREMIO SOLICITADO · PENDIENTE DE VALIDACIÓN',
          'Sultanea Jackpot - Tipo premio':id,
          'Sultanea Jackpot - Partida':activeRoundId,
          'Sultanea Jackpot - Preparar en pedido':note,
          'Sultanea Jackpot - Cantidad de muestras':String(count),
          'Sultanea Jackpot - Tamaño de muestra':String(ml),
          'Sultanea Jackpot - Fragancias elegidas':scents
        };
        chosen.forEach(function(x,i){attrs['Sultanea Jackpot - Perfume de muestra'+(i?' '+(i+1):'')]=x.name;});
        var sameSelected=s.selected===id&&s.selectedRoundId===activeRoundId&&s.selectedRoundIndex===index;
        var approved=window.sjSecureState&&window.sjSecureState.enabled&&!window.sjSecurePreviewTest;
        var verify=approved&&typeof window.sjSecureCall==='function'?
          window.sjSecureCall('jackpot_choose',{roundId:activeRoundId,index:index,samples:chosen.map(function(x){return {variantId:'gid://shopify/ProductVariant/'+String(x.variantId).split('/').pop(),name:x.name};})}).then(function(response){
            if(!response.selection||response.selection.prizeId!==id||response.selection.index!==index||response.selection.roundId!==activeRoundId)throw Error('El servidor no confirma este premio.');
            if(!response.receipt||!response.selection||response.selection.prizeId!==id||!Array.isArray(response.selection.samples)||response.selection.samples.length!==count)throw Error('Falta el justificante firmado del premio.');
            if(typeof window.sjSecureAcceptRound==='function')window.sjSecureAcceptRound(response);
            attrs['Sultanea Jackpot - Justificante firmado']=response.receipt;
            attrs['Sultanea Jackpot - Estado']='ELECCIÓN FIRMADA · PAGO Y CANJE PENDIENTES';
            attrs['Sultanea Jackpot - Partida']=response.selection.roundId;
            scents=response.selection.samples.map(function(x,i){return (i+1)+'. '+x.name;}).join(' | ');
            attrs['Sultanea Jackpot - Fragancias elegidas']=scents;
            response.selection.samples.forEach(function(x,i){attrs['Sultanea Jackpot - Perfume de muestra'+(i?' '+(i+1):'')]=x.name;});
            note='PREPARAR '+label+': '+scents+'. Verificar pedido pagado, tarjeta Sultanea Club y premio antes de entregar.';
            attrs['Sultanea Jackpot - Preparar en pedido']=note;
          }):Promise.resolve();
        return verify.then(function(){
          if(typeof window.sjJackpotSaveOrder!=='function')throw Error('Actualiza el Jackpot antes de elegir tus muestras.');
          return window.sjJackpotSaveOrder(attrs,note);
        }).then(function(updated){
          if(!updated.attributes||updated.attributes['Sultanea Jackpot - Fragancias elegidas']!==scents||String(updated.note||'').indexOf('SULTANEA JACKPOT:')===-1)
            throw Error('Shopify no confirmó la nota del premio.');
          s.selected=id;s.selectedIndex=index;s.selectedRoundId=activeRoundId;s.selectedRoundIndex=index;s.sample=chosen[0];s.samples=chosen;
          localStorage.setItem(storage,JSON.stringify(s));
          window.location.assign(path()+'cart?preview_theme_id='+encodeURIComponent(root.dataset.sjThemeId||''));
        });
      }).catch(function(error){
        busy=false;query.disabled=false;shuffleButton.disabled=false;results.querySelectorAll('button').forEach(function(b){b.disabled=false;});pendingChoices=[];message.textContent=error&&error.message||'No se pudo registrar el premio.';
      });
    }
        document.addEventListener('click',function(ev){
      var b=ev.target.closest&&ev.target.closest('button[data-sj-select],button[data-sj-resend]');
      if(!b||!root.contains(b))return;
      var s=state(),index=b.hasAttribute('data-sj-resend')?s.selectedRoundIndex:Number(b.dataset.sjSelect),roundId=b.dataset.sjRoundId||s.selectedRoundId||s.roundId;
      var reward=(s.rewards||[]).find(function(item){return item.roundId===roundId&&item.index===index}),id=reward?reward.prizeId:s.spins&&s.spins[index];
      if(!Number.isInteger(index)||!isSample(id))return;
      ev.preventDefault();ev.stopImmediatePropagation();open(index,roundId);
    },true);
    change.addEventListener('click',function(){var s=state();open(s.selectedRoundIndex,s.selectedRoundId)});
    shuffleButton.addEventListener('click',function(){clearTimeout(searchTimer);load(query.value.trim());});
    box.querySelector('[data-sjs-back]').addEventListener('click',hide);
    query.addEventListener('input',function(){clearTimeout(searchTimer);searchTimer=setTimeout(function(){load(query.value.trim())},350)});
    results.addEventListener('click',function(ev){var b=ev.target.closest('[data-sample-choice]');if(!b)return;var v=options[Number(b.dataset.sampleChoice)];if(v)saveChoice(v)});
    root.querySelector('[data-sj-open]').addEventListener('click',function(){setTimeout(refresh,0)});
    root.addEventListener('click',function(ev){if(ev.target.closest('[data-sj-reset],[data-sj-qa-force],[data-sj-qa-20],[data-sj-qa-5]'))setTimeout(function(){hide();refresh();},0);});
    refresh();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
})();
